import { render, staticRenderFns } from "./PartnerUriPatterns.vue?vue&type=template&id=31857327&scoped=true&"
import script from "./PartnerUriPatterns.vue?vue&type=script&lang=js&"
export * from "./PartnerUriPatterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31857327",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/partner/sections/PartnerUriPatterns.vue
// module id = 1575
// module chunks = 0